class ScrollButton extends HTMLElement {
  constructor () {
    super()
    this.scrollButton = this.querySelectorAll('.js-button-scroll')
  }

  connectedCallback() {
    this.isScroll()
  }

  isScroll() {
    if (this.scrollButton.length > 0) {
      this.scrollButton.forEach((button) => {
        button.addEventListener('click', () => {
          try {
            const targetElement = getScrollTarget(button?.dataset?.anchorLink)
            const headerHeight = document.getElementById('section-header')?.offsetHeight || 0
  
            if (targetElement) {
              const targetPosition = getOffsetTop(targetElement) - headerHeight + 2
  
              window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
              })
            }
          } catch (error) {
            console.error(error)
          }
        })
      })
    }
  }
}

if (!customElements.get('button-scroll')) {
  customElements.define('button-scroll', ScrollButton)
}

const getOffsetTop = (element) => {
  let offsetTop = 0

  while (element) {
    offsetTop += element.offsetTop
    element = element.offsetParent
  }

  return offsetTop
}

const getScrollTarget = (anchorLink) => {
  const selector = anchorLink?.replace(/^#/, '').trim()

  if (!selector || /[=&]/.test(selector)) {
    return null
  }

  const escapedSelector = window.CSS?.escape ? window.CSS.escape(selector) : selector

  return document.getElementById(selector) || document.querySelector(`.${escapedSelector}`)
}

window.addEventListener('DOMContentLoaded', () => {
  const hashTarget = window.location.hash

  if (hashTarget) {
    setTimeout(() => { // setTimeout() to scroll to the right position after loadpage
      try {
        const targetElement = getScrollTarget(hashTarget)
        const headerHeight = document.getElementById('section-header')?.offsetHeight || 0

        if (targetElement) {
          const targetPosition = getOffsetTop(targetElement) - headerHeight - 4

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          })
        }
      } catch (error) {
        console.error(error)
      }
    }, 1000)
  }
})